import React from 'react';
import Layout from '../../components/layout/Layout';

const AboutPage = () => {
  return (
    <Layout>
      <div className="ph-page">
        <div className="ph-page-header">
          <h1 className="ph-page-title">About the Alliance Partnership Program</h1>
          <p className="ph-page-subtitle">
            Building a comprehensive network of supply chain and industry professionals
          </p>
        </div>

        <div className="ph-page-intro">
          <p>
            The ProductHub Alliance Partnership Program is designed to create a comprehensive ecosystem 
            of verified professionals, companies, and organizations across all sectors of the supply chain 
            and associated industries.
          </p>
          <p>
            Our mission is to connect businesses with everything they need to produce, market, store, 
            distribute, or transport products efficiently and effectively.
          </p>
        </div>

        <div className="ph-panel-grid">
          {/* Vision & Mission */}
          <div className="ph-panel">
            <div className="ph-panel-content">
              <div className="ph-panel-logo">
                <span className="material-icons">visibility</span>
              </div>
              <div className="ph-panel-right">
                <div className="ph-panel-title-row">
                  <h2 className="ph-panel-title">Our Vision</h2>
                </div>
                <div className="ph-panel-content-row">
                  <div className="ph-panel-text">
                    <div className="ph-panel-description">
                      <p>
                        To become the world's most trusted and comprehensive directory of supply chain 
                        professionals, enabling seamless collaboration and business growth across all 
                        industry sectors.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* What We Do */}
          <div className="ph-panel">
            <div className="ph-panel-content">
              <div className="ph-panel-logo">
                <span className="material-icons">business</span>
              </div>
              <div className="ph-panel-right">
                <div className="ph-panel-title-row">
                  <h2 className="ph-panel-title">What We Do</h2>
                </div>
                <div className="ph-panel-content-row">
                  <div className="ph-panel-text">
                    <div className="ph-panel-description">
                      <p>
                        We curate and maintain a comprehensive directory of verified professionals 
                        and companies, provide training and certification programs, and facilitate 
                        meaningful business connections across the supply chain ecosystem.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Who We Serve */}
          <div className="ph-panel">
            <div className="ph-panel-content">
              <div className="ph-panel-logo">
                <span className="material-icons">groups</span>
              </div>
              <div className="ph-panel-right">
                <div className="ph-panel-title-row">
                  <h2 className="ph-panel-title">Who We Serve</h2>
                </div>
                <div className="ph-panel-content-row">
                  <div className="ph-panel-text">
                    <div className="ph-panel-description">
                      <p>
                        Our network serves businesses of all sizes across manufacturing, retail, 
                        logistics, technology, and service industries who need reliable partners 
                        to support their supply chain operations.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Key Benefits */}
          <div className="ph-panel">
            <div className="ph-panel-content">
              <div className="ph-panel-logo">
                <span className="material-icons">star</span>
              </div>
              <div className="ph-panel-right">
                <div className="ph-panel-title-row">
                  <h2 className="ph-panel-title">Key Benefits</h2>
                </div>
                <div className="ph-panel-content-row">
                  <div className="ph-panel-text">
                    <div className="ph-panel-description">
                      <ul className="list-disc list-inside space-y-2 text-gray-700">
                        <li>Access to verified, pre-screened partners</li>
                        <li>Comprehensive training and certification programs</li>
                        <li>Revenue sharing and incentive structures</li>
                        <li>Networking and collaboration opportunities</li>
                        <li>Industry expertise and best practices</li>
                        <li>Technology integration and support</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AboutPage;
